import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/useTreeNode.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useStoreMap } from 'effector-react';
import { getNode } from "../../classifier-service";
import { isReferenceNode, isUserClassifierGroupNode } from "../../classifier-service/Node";
import { createGeneralGroupNode } from "./utils";
export function useTreeNode(_ref) {
  var item = _ref.item,
      nodes$ = _ref.nodes$;
  var node = useStoreMap({
    store: nodes$,
    keys: [item.ref],
    fn: function fn(nodes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          itemRef = _ref3[0];

      if (itemRef.type === 'LoadMore') {
        var _node = getNode(nodes, itemRef.parentNodeRef);

        var parentNode = isReferenceNode(_node) ? getNode(nodes, _node.element) : _node;
        return parentNode ? _objectSpread(_objectSpread({}, itemRef), {}, {
          parentNode: isUserClassifierGroupNode(parentNode) ? createGeneralGroupNode(parentNode) : parentNode
        }) : null;
      }

      if (itemRef.type === 'CreateNode') {
        return itemRef;
      }

      var n = getNode(nodes, itemRef);

      if (!n) {
        return null;
      }

      if (isUserClassifierGroupNode(n)) {
        return createGeneralGroupNode(n);
      }

      if (isReferenceNode(n)) {
        var element = getNode(nodes, n.element);
        return element ? _objectSpread(_objectSpread({}, n), {}, {
          type: 'ReferenceNode',
          element: element
        }) : null;
      }

      if (n.type === 'DynamicBimElementReferenceNode') {
        var _element = getNode(nodes, n.element);

        return _element ? _objectSpread(_objectSpread({}, n), {}, {
          type: 'DynamicReferenceNode',
          element: _element
        }) : null;
      }

      return n;
    }
  });
  return node;
}